<p *ngIf="!ticketAttribute.isDate">{{ticketAttribute.name}}</p>
<mat-button-toggle-group *ngIf="!ticketAttribute.multi && !ticketAttribute.isDate" (change)="fill($event.value)">
  <mat-button-toggle *ngFor="let item of ticketAttribute.possibleValues;" [value]="item">{{item}}</mat-button-toggle>
</mat-button-toggle-group>
<div *ngIf="ticketAttribute.multi" class="answer-container">
  <div *ngFor="let item of ticketAttribute.possibleValues;" (click)="fillMulti(item)" [ngClass]="{'selected': isSelected(item)}">{{item}}</div>
</div>
<mat-form-field *ngIf="ticketAttribute.isDate" class="yellow button-on-top">
  <mat-label class="answer-container">{{ticketAttribute.name}}</mat-label>
  <input matInput [matDatepicker]="picker1" (dateChange)=fillDate($event.value)>
  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
  <mat-datepicker #picker1></mat-datepicker>
</mat-form-field>
<app-button class="button-top" *ngIf="multiValue.length > 0 && (ticketAttribute.multi || ticketAttribute.isDate)" [customColor]="'green'" [title]="'Tovább'" class="create-next-button" (click)="next()"></app-button>
